<template>
    <el-popover
        v-model="visible"
        v-click-outside="closeNotificationPopover"
        width="496"
        trigger="manual"
        :visibleArrow="false"
        popperClass="notifications-popover pt-3 px-2 pb-0"
    >
        <div>
            <el-tabs v-model="activeTab" @tab-click="handleChangeTab">
                <el-tab-pane
                    :label="$t.__('header.Notifications.notifications')"
                    name="notifications"
                >
                    <notifications-list
                        v-if="visible && activeTab === 'notifications'"
                        :unreadNotificationsCounter="unreadNotificationsCounter"
                    />
                </el-tab-pane>
                <el-tab-pane :label="$t.__('header.Notifications.alert')" name="alerts">
                    <ul v-if="alerts && hasAlertsSetuped" id="alerts-list">
                        <li
                            v-for="(alert, name) in alerts"
                            :id="'notif-' + alert.name"
                            :key="name"
                            class="headnotif p-1"
                        >
                            <div class="headnotif-header br" @click="triggerAlertCallback(alert)">
                                <div class="label label-nobackground">
                                    <span
                                        :class="
                                            'spanLabel spanLabelNotif ' +
                                            (alert.nbAlerts > 0
                                                ? 'spanLabel-red'
                                                : 'spanLabel-lightgrey-disabled')
                                        "
                                    >
                                        {{ alert.nbAlerts > 1000 ? '1000+' : alert.nbAlerts }}
                                    </span>
                                </div>
                                <span class="name">{{ alert.txt }}</span>
                            </div>
                            <div class="headnotif-detail hidden"></div>
                        </li>
                    </ul>
                    <div v-else-if="alerts && !hasAlertsSetuped" class="placeholder">
                        <p>{{ $l10n.__("Aucune alerte n'est paramétrée") }}</p>
                        <CompassButton
                            :label="$t.__('header.Notifications.configure_alert')"
                            class="mb-2"
                            @click="redirectToProfilPreferences"
                        />
                    </div>
                    <div v-else class="placeholder">
                        <p>{{ $l10n.__('Chargement des alertes') }}</p>
                        <br />
                        <i class="fa fa-spin fa-cog fa-blue fa-30"></i>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <CompassIconButton
                icon="settings-fill"
                class="notifications__settings-icon"
                @click="redirectToProfilPreferences"
            />
        </div>
        <CompassTooltip
            slot="reference"
            :content="$t.__('header.Notifications.notifications')"
            placement="bottom"
            contentClass="navbar-tooltip"
            :arrow="false"
        >
            <a href="javascript:;" class="navbar-content__actions--item-link">
                <CompassIcon icon="notification" class="navbar-content__actions--item-icon" />
                <span
                    class="navbar-content__actions--item-label typographies-paragraph-small-regular"
                >
                    {{ $l10n.__('Notifications') }}
                </span>
                <chip-number
                    v-if="unreadNotificationsCounter"
                    class="navbar-content__actions--item-chip"
                    :number="unreadNotificationsCounter"
                />
            </a>
        </CompassTooltip>
    </el-popover>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import NotificationsList from 'vcomponents/notifications/NotificationsList.vue';
import NotificationApi from 'api/notification/Notification';
import ChipNumber from 'vcomponents/utilities/ChipNumber.vue';
import LocalStorage from 'Core/commons/LocalStorage';

export default {
    components: {
        NotificationsList,
        ChipNumber,
    },
    data() {
        return {
            alerts: null,
            activeTab: null,
            visible: false,
            unreadNotificationsCounter: null,
            localstorage: new LocalStorage('notification', 'last_tab'),
            localStorageCountUnreadNotif: null,
        };
    },

    computed: {
        /**
         * @returns bool
         */
        hasAlertsSetuped() {
            if (!this.alerts) {
                return false;
            }

            if (Object.values(this.alerts).length === 0) {
                return false;
            }

            return true;
        },
    },
    watch: {
        unreadNotificationsCounter(newVal, oldVal) {
            if (newVal !== oldVal && newVal !== this.localStorageCountUnreadNotif.get('payload')) {
                this.localStorageCountUnreadNotif.setex(newVal, 120000); //120 000 ms => 2 minutes for ttl
            }
        },
    },
    created() {
        const staffId = this.$store.getters['user/getUser'].id;
        this.localStorageCountUnreadNotif = new LocalStorage(
            'notification',
            `count_unread_${staffId}`,
        );
        this.activeTab =
            this.localstorage.get() !== null ? this.localstorage.get() : 'notifications';
        if (this.activeTab === 'alerts') {
            this.getAlerts();
        }
    },
    mounted() {
        document
            .getElementById('headermenu_notif')
            .addEventListener('click', this.toggleNotificationPopover, false);
        this.getUnreadNotificationsCounter();
    },
    events: {
        'notification:unread:increment': 'incrementUnreadNotificationCounter',
        'notification:unread:decrement': 'decrementUnreadNotificationCounter',
        'notification:unread:resetUnreadNotifCounter': 'resetUnreadNotifCounter',
        'notification:panel:close': 'closeNotificationPopover',
    },
    methods: {
        /**
         * notification object is sent by backend (so the eval).
         * @todo Refactorise when logic will be deported on frontend.
         *
         * @var {Object} notification
         */
        triggerAlertCallback(alert) {
            if (alert.nbAlerts > 0 || (alert.forceAction && alert.forceAction === 'Y')) {
                eval(alert.action);
            } else if (alert.nbAlerts === 0 && alert.offAction && alert.offAction !== '') {
                eval(alert.offAction);
            }
        },
        getAlerts() {
            if (!document.hidden) {
                //Old api route for alerts fetching
                this.$ajax.get('/alerts').then((response) => {
                    this.alerts = response.data;
                });
            }
        },
        handleChangeTab(tab, event) {
            this.localstorage.set(tab.name);

            if (tab.name === 'alerts') {
                this.getAlerts();
            }
        },
        toggleNotificationPopover() {
            this.visible = !this.visible;
        },
        getUnreadNotificationsCounter() {
            if (this.localStorageCountUnreadNotif.get('payload') !== null) {
                this.unreadNotificationsCounter = this.localStorageCountUnreadNotif.get('payload');
            } else {
                NotificationApi.getUnreadNotifications()
                    .then((res) => {
                        this.unreadNotificationsCounter = res.data.pagination.total;
                    })
                    .catch((err) => {
                        Push.error(
                            this.$l10n.__(
                                'Une erreur est survenue lors de la récupération des notifications.',
                            ),
                        );
                    });
            }
        },
        incrementUnreadNotificationCounter() {
            this.localstorage.set('notifications');
            this.activeTab = 'notifications';
            this.unreadNotificationsCounter++;
        },
        decrementUnreadNotificationCounter() {
            if (this.unreadNotificationsCounter > 0) {
                this.unreadNotificationsCounter--;
            }
        },
        closeNotificationPopover() {
            if (this.visible === true) {
                this.visible = false;
            }
        },
        resetUnreadNotifCounter() {
            this.unreadNotificationsCounter = 0;
        },

        redirectToProfilPreferences() {
            return goToUrl('/?_f=profilPreferences&action=notificationInApp');
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_mixins';
@import '~@sellsy/styleguide/src/_variables';

.notifications-popover {
    z-index: 2001 !important;
    min-height: 582px;
    border: none !important;

    .el-tabs__header {
        margin-bottom: 0 !important;

        &.is-top {
            margin: 0;
        }

        .el-tabs__nav-wrap::after {
            right: 8px;
            left: 8px;
            width: auto;
        }

        .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav.is-top {
            #tab-notifications.el-tabs__item.is-top {
                padding-left: 8px !important;
            }
        }
    }
}

.navbar-content__actions--item-link {
    padding: var(--spacing-0);
    position: relative;

    .navbar-content__actions--item-chip {
        position: absolute;
        top: 0;
        right: -4px;
        font-size: var(--font-size-10);
    }
}

#compass-tooltip-container {
    .tooltip-notif-center {
        z-index: 2002;
    }
}
</style>

<style lang="scss" scoped>
.notifications {
    &__settings-icon {
        position: absolute;
        top: 6px;
        right: 16px;
        cursor: pointer;
        color: var(--colors-common-text-standard-default);
    }
}
</style>
